import { render } from "./AreaClient.vue?vue&type=template&id=59eea2e0"
import script from "./AreaClient.vue?vue&type=script&lang=js"
export * from "./AreaClient.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__